import { Button } from "@/components/ui/button"
import { ChevronRight, UserMinus } from "lucide-react"
import { Link } from "react-router-dom"
import { HomePageOrganizationRowProps } from "."
import ErrorPopup from "@/components/custom/InfoPopups/ErrorPopup"
import SuccessPopup from "@/components/custom/InfoPopups/SuccessPopup"
import { useUserStore } from "@/lib/zustand/useStore"
import DecisionModal from "@/components/custom/InfoPopups/DecisionModal"
import { useDeleteOrganization } from "@/features/organization/hooks/useMutation/useDeleteOrganization"
import { ConfirmByTypingTextDialog } from "@/components/organisms/ConfirmByTypingTextDialog"
import { useState } from "react"
import { useLeaveOrganization } from "@/features/organization/hooks/useMutation/useLeaveOrganization"

export function HomePageOrganizationRow({
    org,
}: HomePageOrganizationRowProps) {
    const { mutateAsync: leaveOrganization } = useLeaveOrganization()
    const { mutateAsync: deleteOrganization } = useDeleteOrganization()
    const user = useUserStore()

    const [isConfirmingDelete, setIsConfirmingDelete] = useState(false)
    const handleDeleteOrganization = async () => {
        try {
            await deleteOrganization({
                orgId: org.id,
            })
            SuccessPopup("You have successfully left and deleted the organization.")
        } catch (error) {
            console.error(error)
            ErrorPopup("Failed to leave and delete organization, try again later.")
        }
    }
    const handleLeaveOrganization = async () => {
        if (user?.id === org.owner_id) {
            const decision = await DecisionModal({
                title: "Are you sure?",
                message: "You are about to leave organization that you are owner of. This action cannot be undone and will result in deletion of the organization with all it's members.",
                confirmButtonText: "Leave and delete organization",
                cancelButtonText: "Cancel",
            })
            if (decision.isConfirmed) {
                // handleDeleteOrganization()
                setIsConfirmingDelete(true)
            }
        } else {
            const decision = await DecisionModal({
                title: "Are you sure?",
                message: "You are about to leave organization. You won't be able to join it until you receive invitation again.",
                confirmButtonText: "Leave",
                cancelButtonText: "Cancel",
            })
            if (decision.isConfirmed) {
                try {
                    await leaveOrganization(org.id)
                    SuccessPopup("You have successfully left the organization.")
                } catch (error) {
                    console.error(error)
                    ErrorPopup("Failed to leave organization, try again later.")
                }
            }
        }
    }
    return (
        <>
            <ConfirmByTypingTextDialog
                onSubmit={() => {
                    handleDeleteOrganization()
                }}
                confirmText={org.name!}
                open={isConfirmingDelete}
                onOpenChange={setIsConfirmingDelete}
            />
            <div className="flex items-center justify-between gap-3 px-3 py-2 bg-white border border-gray-300 rounded-lg">
                <div className="grow">
                    <div className="text-sm font-semibold break-words">{org.name || <span className="italic font-normal text-red-600">Missing name</span>}</div>
                </div>
                <div className="flex flex-col gap-1">
                    <Link to={`/organization/${org.id}?showMenu=true`}>
                        <Button size="sm">
                            Open <ChevronRight size={16} />
                        </Button>
                    </Link>

                    <Button size="sm" variant="destructive" onClick={handleLeaveOrganization}>
                        Leave <UserMinus size={16} />
                    </Button>
                </div>
            </div>
        </>
    )
}
